export default __webpack_public_path__ + "static/media/sentro_logomark3.59abc335.png";